import { ITheme } from "../../utils/theme";

export const wrapperStyle = {
  borderRadius: '8px',
}

export const contentWrapperStyle = {
  overflow: 'auto',
  py: 0.5,
  // Uncomment below to hide scrollbars
  // "&::-webkit-scrollbar": {
  //   display: 'none',
  // },
  // msOverflowStyle: 'none',
  // scrollbarWidth: 'none',
}

export const scrollIndicatorBarStyle = {
  display: 'flex',
  alignItems: 'center',
  height: '12px',
  "& svg": {
    fontSize: 'large',
    color: (theme: ITheme) => theme.palette.grey[900],
  },
}
